
import React, {useEffect, useState} from "react";
import { useFetch } from "../../../components/common/FetchProvider";
import ErrorModal from "../reports/components/ErrorModal";
import {formatNumberToInternational} from "../../../utils/utils";
import AccountBalanceTable from "./components/AccountBalanceTable";
import { balanceTableColumns } from "./variables/columnsData";
import Loader from "../../../components/Loader/Loader";


const Dashboard = () => {
  const fetchWrapper = useFetch();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [monthYear, setMonthYear] = useState("");

  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      let apiUrl = `${process.env.REACT_APP_API_URL}/v1/home`;

      const userToken = localStorage.getItem("token");
      const response = await fetchWrapper(apiUrl, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      setLoading(false);
      if (response.ok) {
        const responseData = await response.json();
        if (responseData.data && responseData.data.balances.length > 0) {
          setApiData(responseData.data.balances);
          setMonthYear(responseData.data.monthYear)
        }
      }
    } catch (error) {
      setLoading(false);
      if (error.body && error.body.responseInfo) {
        setErrorMessage(error.body.responseInfo.message);
        setShowErrorModal(true);
      } else {
        console.error("Error: Unable to handle ", error);
        setErrorMessage("Ocorreu um erro inesperado");
        setShowErrorModal(true);
      }
    }
  };

  let mappedApiData = apiData.map((item) => ({
    name: item.name,
    accountType: item.accountType,
    accountName: item.accountName,
    accountNumber: item.accountNumber,
    accountCurrency: item.accountCurrency,
    balance: formatNumberToInternational(item.balance),
  }));

  return (
      <div className="10">
        <Loader show={loading} />
        {showErrorModal &&
            <ErrorModal
                showErrorModal={showErrorModal}
                setShowErrorModal={setShowErrorModal}
                errorMessage={errorMessage}
            />
        }

<div className="mt-5 rounded-xl bg-white p-8 shadow-lg dark:!bg-navy-800 dark:shadow-none 2xl:grid-cols-11">
        <p className="text-2xl font-bold text-navy-700 dark:text-white">
        SEJA BEM VINDO AO BRISA DC
        </p>
        <p className="mt-5 mb-2 text-base font-normal text-black-600">
  O <span className="text-red-600 font-bold">BRISA MDC</span> e um softwer que foi criada para apoio incondicional aos ADF na elaboracao dos Relatorios de Prestacao de Contas e Tribunal de Contas e e propriedade exclusiva do Grupo Brisa
</p>

        <p className="mb-2 text-base font-normal text-gray-600">
        Com esta ferramenta o Co-Gestor tera a vida facilitada e permitira que as sua Prestacoes de Contas sejam elaboradas a um tempo record,
        </p>
        <p className="mb-2 text-base font-normal text-red-600">
        Direitos Reservados ao GRUPO BRISA
        </p>
      </div>

        <div className="mt-5">
        <p className="text-center font-bold mb-2">{monthYear}</p>
        {loading ? (
            <p>Loading...</p>
        ) : mappedApiData && mappedApiData.length > 0 ? (
            <AccountBalanceTable
                columnsData={balanceTableColumns} // Pass the correct columns
                tableData={apiData} // Pass the mapped data
            />
        ) : (
            <></>
        )}
      </div>

      </div>
  );
};

export default Dashboard;
